<template>
	<div class="wind-img">
		<img :src="imgSrc" :onerror="imgErrorHandler" @click="onClick">
	</div>
</template>

<script type="text/babel">
const QING_URL_1 = 'http://fx-ygyl.pek3a.qingstor.com'
const QING_URL_2 = 'https://fx-ygyl.pek3a.qingstor.com'
const ALIYUN_URL = 'https://fxscms.oss-cn-beijing.aliyuncs.com'
export default {
	name: 'w-img',
	props: {
		src: [String, Array, null],
		type: {
			type: String,
			default: 'item'
		},
		qingStorDefault: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		imgSrc () {
			let src = ''
			if (Array.isArray(this.src)) {
				src = this.src[0]
			} else {
				src = this.src
			}
			src = this.$fxCommon.urlQingstorToAliyuncs(src)
			return src && src.length ? src : this.$fxCommon.getDefaultImg(this.type)
		},
		imgErrorHandler () {
			let tryUrl = this.imgSrc
			if (tryUrl.indexOf(QING_URL_1) === 0) {
				tryUrl = ALIYUN_URL + tryUrl.substr(QING_URL_1.length)
			} else if (tryUrl.indexOf(QING_URL_2) === 0) {
				tryUrl = ALIYUN_URL + tryUrl.substr(QING_URL_2.length)
			}
			tryUrl = tryUrl.replace(/\\/g, '/')
			return `this.onerror=null;this.src='${tryUrl}'`
		}
	},
	methods: {
		onClick () {
			this.$emit('on-click')
		}
	}
}
</script>
<style scoped>
.wind-img {
	width: 100px;
	height: 100px;
	padding: 10px;
	box-sizing: border-box;
}
.wind-img>img {
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// Img.vue?2874950e